import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const PurchaseRequisitionList = () => {
    const [requisitions, setRequisitions] = useState([]);
    const [filteredRequisitions, setFilteredRequisitions] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();

    // Fetch purchase requisitions when the component mounts
    useEffect(() => {
        fetch('http://localhost:8000/api/purchaseRequisition')
            .then(response => response.json())
            .then(data => {
                setRequisitions(data.data || []);
                setFilteredRequisitions(data.data || []);
            })
            .catch(error => console.error('Error fetching purchase requisitions:', error));
    }, []);

    // Handle search input
    const handleSearchChange = (event) => {
        const term = event.target.value;
        setSearchTerm(term);

        const filtered = requisitions.filter(req =>
            Object.values(req).some(value =>
                value && value.toString().toLowerCase().includes(term.toLowerCase())
            )
        );
        setFilteredRequisitions(filtered);
    };

    // Navigate to add new purchase requisition
    const handleAdd = () => {
        navigate('/AddPurchaseRequisition');
    };

    // Navigate to edit page for a specific requisition
    const handleEdit = (id) => {
        navigate(`/EditPurchaseRequisition/${id}`);
    };

    // Handle delete functionality
    const handleDelete = (id) => {
        if (window.confirm('Are you sure you want to delete this requisition?')) {
            fetch(`http://localhost:8000/api/purchaseRequisition/${id}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then(response => response.json())
                .then(data => {
                    if (data.status === 1) {
                        // Remove the deleted requisition from both lists
                        setRequisitions(requisitions.filter(req => req.id !== id));
                        setFilteredRequisitions(filteredRequisitions.filter(req => req.id !== id));
                        alert('Requisition deleted successfully.');
                    } else {
                        alert('Failed to delete requisition. Please try again.');
                    }
                })
                .catch(error => console.error('Error deleting requisition:', error));
        }
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Purchase Requisition List</h3>
                        </div>
                        <div className="col-12 col-md-6 order-md-2 order-first">
                            <nav aria-label="breadcrumb" className="breadcrumb-header float-start float-lg-end">
                                <ol className="breadcrumb"></ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section">
                <div className="row" id="basic-table">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <div className="row">
                                    <div className="col-md-6"></div>
                                    <div className="col-md-6 text-end">
                                        <button className="btn btn-primary" onClick={handleAdd}>Add Requisition</button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="mb-3">
                                    <label htmlFor="searchTerm" className="form-label">Search</label>
                                    <input
                                        type="text"
                                        id="searchTerm"
                                        className="form-control"
                                        placeholder="Search by any field"
                                        value={searchTerm}
                                        onChange={handleSearchChange}
                                    />
                                </div>
                                <div className="table-responsive">
                                    <table className="table table-lg">
                                        <thead>
                                            <tr>
                                                <th>Pack Unit</th>
                                                <th>Pack Qty</th>
                                                <th>Unit</th>
                                                <th>Quantity</th>
                                                <th>Rate</th>
                                                <th>Amount</th>
                                                <th>MRP</th>
                                                <th>Net Rate</th>
                                                <th>Remark</th>
                                                <th>Item Barcode</th>
                                                <th>Item Balance</th>
                                                <th>Line Barcode</th>
                                                <th>HSN Code</th>
                                                <th>Brand</th>
                                                <th>Created At</th>
                                                <th className="text-end">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredRequisitions.map(req => (
                                                <tr key={req.id}>
                                                    <td>{req.pack_unit || 'N/A'}</td>
                                                    <td>{req.pack_qty || 'N/A'}</td>
                                                    <td>{req.unit || 'N/A'}</td>
                                                    <td>{req.quantity || 'N/A'}</td>
                                                    <td>{req.rate || 'N/A'}</td>
                                                    <td>{req.amount || 'N/A'}</td>
                                                    <td>{req.mrp || 'N/A'}</td>
                                                    <td>{req.net_rate || 'N/A'}</td>
                                                    <td>{req.remark || 'N/A'}</td>
                                                    <td>{req.item_barcode || 'N/A'}</td>
                                                    <td>{req.item_balance || 'N/A'}</td>
                                                    <td>{req.line_level_barcode || 'N/A'}</td>
                                                    <td>{req.hsn_code || 'N/A'}</td>
                                                    <td>{req.brand || 'N/A'}</td>
                                                    <td>{new Date(req.created_at).toLocaleString() || 'N/A'}</td>
                                                    <td className="text-end">
                                                        <button className="btn btn-success" onClick={() => handleEdit(req.id)}>Edit</button>
                                                        <button className="btn btn-danger ms-2" onClick={() => handleDelete(req.id)}>Delete</button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default PurchaseRequisitionList;
